module.exports = __webpack_public_path__ + "static/media/logo-text.d2957c08.svg";